import { render, staticRenderFns } from "./flyersEditor.vue?vue&type=template&id=53e9fc42&scoped=true&"
import script from "./flyersEditor.vue?vue&type=script&lang=js&"
export * from "./flyersEditor.vue?vue&type=script&lang=js&"
import style0 from "./flyersEditor.vue?vue&type=style&index=0&id=53e9fc42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e9fc42",
  null
  
)

export default component.exports